{
  "chainId": 998,
  "vault": "0x88CddADA26386d39BDf79B67Fd02d9C0274ED5F9",
  "operator": "0x1C0fD87Cc4967Bb4b1433491cc98d90E92791E7F",
  "gameSetId": "31",
  "games": [
    {
      "name": "over-under",
      "gameIndex": 0,
      "rootValuePpm": 979999,
      "maxValuePpm": 20298788,
      "ladder": [
        1132645,
        1472438,
        1914169,
        2488419,
        3234944,
        4205427,
        5467055,
        7107171,
        9239322,
        12011118,
        15614453,
        20298788
      ]
    },
    {
      "name": "over-under-sprint",
      "gameIndex": 1,
      "rootValuePpm": 979999,
      "maxValuePpm": 3260276,
      "ladder": [
        1141514,
        1483968,
        1929158,
        2507905,
        3260276
      ]
    }
  ]
}
